<template>
  <div class="login-container">
    <!-- Background Image -->
    <div class="background-image"></div>
    <div class="fvf_background_overlay"></div>

    <!-- Main Layout -->
    <div class="container-fluid min-vh-100 d-flex p-0">
      <div class="row w-100 m-0">
        <!-- Left Side: Image -->
        <div class="col-lg-6 d-none d-lg-block p-5 d-flex align-items-center">
          <div class="left-image-wrapper h-100 w-100">
            <img
              src="../../../public/img/img_login.jpg"
              alt="Login Image"
              class="left-image"
            />
          </div>
        </div>

        <!-- Right Side: Form -->
        <div
          class="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center position-relative"
        >
          <div class="login-content-wrapper w-100">
            <!-- Logos -->
            <div class="d-flex justify-content-center align-items-center mb-4 gap-4">
              <div class="logo-box">
                <img
                  src="../../../public/img/ccd_escudo.png"
                  class="escudo-logo escudo-ccd"
                  alt="CCD Logo"
                />
              </div>
              <div class="logo-divider"></div>
              <div class="logo-box">
                <img
                  src="../../../public/img/fvf_escudo.png"
                  class="escudo-logo escudo-fvf"
                  alt="FVF Logo"
                />
              </div>
            </div>

            <div class="text-center mb-4">
              <h1 class="font-weight-bolder text-white mb-2">BIENVENIDO</h1>
              <p class="text-white mb-0" style="font-size: 1.1rem">
                Ingresa tus datos para ingresar al panel del<br />
                Centro de Capacitación y Desarrollo de la FVF
              </p>
            </div>

            <div class="form-container mx-auto">
              <form role="form" class="d-flex flex-column gap-1">
                <div>
                  <label for="email" class="form-label text-white pl-3">Correo</label>
                  <input
                    type="email"
                    id="email"
                    v-model="model.email"
                    class="form-control"
                    placeholder="Ingresa tu correo"
                    aria-label="Email"
                    v-on:keyup.enter="$refs.secondInput.focus()"
                    v-on:keyup.down="$refs.secondInput.focus()"
                    ref="firstInput"
                  />
                </div>

                <div>
                  <label for="password" class="form-label text-white pl-3"
                    >Contraseña</label
                  >
                  <div class="password-input-container">
                    <input
                      :type="showPassword ? 'text' : 'password'"
                      id="password"
                      v-model="model.password"
                      class="form-control"
                      placeholder="Ingresa tu contraseña"
                      aria-label="Password"
                      v-on:keyup.enter="OnSubmit"
                      v-on:keyup.up="$refs.firstInput.focus()"
                      ref="secondInput"
                    />
                    <button
                      type="button"
                      class="password-toggle-btn"
                      @click="togglePassword"
                      :title="
                        showPassword
                          ? 'Ocultar contraseña'
                          : 'Mostrar contraseña'
                      "
                    >
                      <v-icon
                        :icon="['fas', showPassword ? 'eye-slash' : 'eye']"
                        :style="{ color: '#b49b57', fontSize: '1.1rem' }"
                      />
                    </button>
                  </div>
                </div>
                
                <div class="d-flex justify-content-end">
                  <a href="recover" class="text-white text-sm text-decoration-none"
                    >Olvidé mi contraseña</a
                  >
                </div>

                <div class="text-center mt-3">
                  <button
                    type="button"
                    class="btn golden-btn mb-0 w-100"
                    @click="OnSubmit"
                  >
                    Ingresar
                  </button>
                </div>

                <div class="text-center mt-2">
                  <button
                    type="button"
                    class="btn rne-btn mb-0 w-100 d-flex align-items-center justify-content-center gap-2"
                    @click="goToRneLogin"
                  >
                    <v-icon :icon="['fas', 'id-card']" :style="{ fontSize: '1.1rem' }" />
                    Acceder con RNE
                  </button>
                </div>

                <div class="text-center mt-4">
                  <p class="text-white mb-0">
                    ¿No tienes cuenta? 
                    <a @click.prevent="showRegistrationAlert" style="color: #BC9A52" class="font-weight-bold text-decoration-underline ml-1 cursor-pointer">Regístrate acá</a>
                  </p>
                </div>
              </form>
            </div>
            
                <div class="text-center mt-4">
                  <p class="text-muted text-sm mb-0" style="color: #a0a0a0 !important;">
                   &copy; {{ currentYear }} FVF / CCD By <a href="https://ticz.io/" target="_blank" rel="noopener noreferrer" class="ticz-link">TICZ</a>
                  </p>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import LayoutFooter from "./Layouts/Footer";
import { mapActions } from "vuex";
import Cookies from "js-cookie";
export default {
  name: "login",
  role: Cookies.get("id_role"),
  components: {
    LayoutFooter,
  },
  data() {
    return {
      window_title: "Bienvenido al CCD",
      description: "Indica tus credenciales para acceder",
      version_control: "2.0",
      model: {
        email: "",
        password: "",
      },
      showPassword: false,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    ...mapActions(["login"]),

    OnSubmit() {
      if (this.model.email == "" || this.model.password == "") {
        Swal.fire({
          title: "Atención",
          text: "Complete todos los campos para continuar",
          icon: "warning",
          customClass: {
            confirmButtonColor: "#B49B57",
            confirmButton: "btn-info",
          },
        });
      } else {
        Swal.showLoading();
        this.login(this.model)
          .then((response) => {
            if (response.code == 200) {
              this.$router.push("/overview");
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              });
              Toast.fire({
                icon: "success",
                title: "¡Bienvenido!",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            }
          })
          .catch((error) => {
            console.log(error);
             if (error.code == 401) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "La contraseña ingresada no pertenece a la dirección de correo electrónico",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            } 
           else if (error.code == 402) {
              Swal.fire({
                title: "Credenciales inválidas",
                text: "La contraseña ingresada no pertenece a la dirección de correo electrónico",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            } else if (error.code == 403) {
              Swal.fire({
                title: "Usuario bloqueado",
                text: "El usuario está bloqueado por múltiples intentos fallidos. Por favor, contacte al administrador",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            } else if (error.code == 404) {
              Swal.fire({
                title: "Usuario no encontrado",
                text: "No hay ningún usuario registrado con la dirección de correo electrónico ingresada",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            } else {
              Swal.fire({
                title: "¡Ocurrió un error!",
                text: "Usuario no registrado, intente nuevamente",
                icon: "warning",
                customClass: {
                  confirmButtonColor: "#B49B57",
                  confirmButton: "btn-info",
                },
              });
            }
          });
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    goToRneLogin() {
      this.$router.push("/registro-rne");
    },
    showRegistrationAlert() {
      Swal.fire({
        title: "Selecciona tu tipo de registro",
        text: "Si eres entrenador con licencia, debes acceder a través del botón 'Acceder con RNE'. Si no eres entrenador, continúa con el registro normal.",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Soy entrenador (RNE)",
        cancelButtonText: "No soy entrenador",
        customClass: {
          confirmButton: "btn-info",
          cancelButton: "btn-info",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.goToRneLogin();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          this.$router.push("/registro");
        }
      });
    },
  },
};
</script>
<style scoped>
/* Login container and background */
.login-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
}

.background-image {
  background-image: url("../../../public/img/background.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: -2;
}

.fvf_background_overlay {
  position: fixed;
  top: 0; 
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(53, 16, 32, 0.4); /* Reduced opacity to show background */
  z-index: -1;
}

/* Left Side Image */
.left-image-wrapper {
  border-radius: 30px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0,0,0,0.3);
  height: 85vh !important; 
  width: 100%;
}

.left-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Content Wrapper */
.login-content-wrapper {
  max-width: 600px;
  width: 90%;
  z-index: 2;
}

/* Logos */
.logo-box {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.escudo-logo {
  object-fit: contain;
  filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.2));
}

.escudo-ccd {
  height: 113px;
  width: auto;
}

.escudo-fvf {
  height: 120px;
  width: auto;
}

.logo-divider {
  width: 1px;
  height: 120px;
  background-color: rgba(255, 255, 255);
}

/* Form Container */
.form-container {
  width: 100%;
  max-width: 400px;
}

/* Form controls */
.form-control {
  background: white !important;
  border-radius: 30px !important;
  border: none;
  padding: 12px 20px;
  height: 50px;
  color: #333 !important;
  font-size: 0.95rem;
}

.form-control:focus {
  background: white !important;
  box-shadow: 0 0 0 3px rgba(180, 155, 87, 0.3);
  color: #333;
}

.form-control::placeholder {
  color: #aaa;
}

.form-label {
  font-weight: 400;
  font-size: 0.9rem;
  margin-bottom: 4px;
  opacity: 0.9;
}

/* Login button */
.golden-btn {
  background: #b49b57;
  color: white;
  border-radius: 30px !important;
  padding: 12px 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(180, 155, 87, 0.3) !important;
  transition: all 0.3s ease;
  height: 50px;
  font-size: 1.1rem;
}

.golden-btn:hover {
  background: #cbb16a;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(180, 155, 87, 0.4) !important;
}

/* RNE button */
.rne-btn {
  background: white;
  color: #b49b57;
  border: 2px solid #b49b57;
  border-radius: 30px !important;
  padding: 12px 20px;
  font-weight: 700;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(180, 155, 87, 0.3) !important;
  transition: all 0.3s ease;
  height: 50px;
  font-size: 1.1rem;
}

.rne-btn:hover {
  background: #f5f5f5;
  color: #b49b57;
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(180, 155, 87, 0.4) !important;
}

/* Password toggle */
.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle-btn {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  z-index: 10;
}

.password-input-container .form-control {
  padding-right: 50px;
}

/* Responsive Design */
@media (max-width: 991px) {
  /* Tablet and below - hide left image, center form */
  .login-content-wrapper {
    max-width: 500px;
    padding: 20px;
  }
  
  .form-container {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  /* Mobile - smaller logos and form elements */
  .logo-box {
    width: 70px;
    height: 70px;
  }
  
  .escudo-ccd {
    height: 89px;
  }
  
  .escudo-fvf {
    height: 95px;
  }
  
  .logo-divider {
    height: 95px;
  }
  
  .login-content-wrapper {
    max-width: 100%;
    width: 95%;
    padding: 15px;
  }
  
  .form-container {
    max-width: 100%;
  }
  
  .form-control {
    height: 48px;
    font-size: 0.9rem;
    padding: 10px 18px;
  }
  
  .golden-btn {
    height: 48px;
    font-size: 1rem;
  }
  
  h1 {
    font-size: 1.75rem !important;
  }
  
  .text-center p {
    font-size: 0.95rem !important;
  }
}

@media (max-width: 576px) {
  /* Small mobile - even more compact */
  .logo-box {
    width: 60px;
    height: 60px;
  }
  
  .escudo-ccd {
    height: 77px;
  }
  
  .escudo-fvf {
    height: 80px;
  }
  
  .logo-divider {
    height: 80px;
  }
  
  .login-content-wrapper {
    width: 100%;
    padding: 10px;
  }
  
  .form-container {
    padding: 0 10px;
  }
  
  .form-control {
    height: 45px;
    font-size: 0.85rem;
    padding: 10px 15px;
  }
  
  .golden-btn {
    height: 45px;
    font-size: 0.95rem;
    padding: 10px 18px;
  }
  
  .password-input-container .form-control {
    padding-right: 45px;
  }
  
  h1 {
    font-size: 1.5rem !important;
  }
  
  .text-center p {
    font-size: 0.85rem !important;
  }
  
  .form-label {
    font-size: 0.85rem;
  }
  
  .gap-4 {
    gap: 1rem !important;
  }
}

@media (min-width: 992px) and (max-width: 1199px) {
  /* Small desktop - adjust image size */
  .left-image-wrapper {
    height: 80vh !important;
  }
  
  .login-content-wrapper {
    max-width: 500px;
  }
}

@media (min-width: 1200px) {
  /* Large desktop - more spacing */
  .login-content-wrapper {
    max-width: 650px;
  }
  
  .form-container {
    max-width: 450px;
  }
}
</style>
<style>
input:-webkit-autofill,
input:-webkit-autofill:focus,
input:-webkit-autofill:hover,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 1000px white inset !important;
  box-shadow: 0 0 0 1000px white inset !important;
  -webkit-text-fill-color: #333 !important;
  background-color: white !important;
  transition: background-color 5000s ease-in-out 0s !important;
}

.gradient-custom-2 {
  /* fallback for old browsers */
  background: #fccb90;

  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(
    to right,
    #ee7724,
    #d8363a,
    #dd3675,
    #b44593
  );

  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, #ee7724, #d8363a, #dd3675, #b44593);
}

@media (min-width: 768px) {
  .gradient-form {
    height: 100vh !important;
  }
}

@media (min-width: 769px) {
  /* .gradient-custom-2 {
    border-top-right-radius: .3rem;
    border-bottom-right-radius: .3rem;
  } */
}

body {
  font-family: "Jost" !important;
  /* text-transform: uppercase !important; */
}

.card .card-body {
  font-family: "Jost" !important;
}

.page-header .container {
  margin: 0px;
  padding: 0px;
  z-index: 0;
}

.fvf_background {
  /* background-image: url("../../../public/img/login-fondo.jpg");  */
  background-color: rgb(53, 16, 32, 0.8) !important;
  backdrop-filter: blur(2px);
  /* Add the blur effect */
  height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
}
.fvf_img {
  background-image: url("../../../public/img/login-fondo.jpg");
  /* Center and scale the image nicely */
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
  top: 0%;
  position: absolute;
}

.fvf_logo {
  filter: blur(0px) !important;
  z-index: 5;
  position: absolute;
  top: 40%;
  left: 10%;
}

.form-control {
  border-radius: 30px !important;
}

.btn {
  border-radius: 30px !important;
  box-shadow: 0 4px 7px -1px #b49b57, 0 2px 4px -1px #b49b57 !important;
}

.bg-gradient-fvf {
  background-color: rgb(53, 16, 32) !important;
  color: white !important;
}

.bg-gradient-fvf-switch {
  background-color: white !important;
  color: rgb(53, 16, 32) !important;
  box-shadow: none !important;
}

.text-gradient-fvf {
  color: rgb(53, 16, 32);
}

.text-fvf {
  color: #b49b57;
}

.multiselect__tags {
  border-radius: 30px !important;
}

.multiselect__content-wrapper {
  border-radius: 30px !important;
  position: absolute;
  z-index: 1;
}

/* .swal2-container.swal2-center > .swal2-popup {
  background-color:#541A32 !important;
  color: #B49B57 !important;
   
} */

.swal2-container.swal2-center > .swal2-popup {
  z-index: 10000 !important;
}

.swal2-container {
  z-index: 10000 !important;
}

.swal2-styled.swal2-confirm {
  background-color: #541a32 !important;
  color: white !important;
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.swal2-styled.swal2-cancel {
  border-radius: 30px !important;
  z-index: 10000 !important;
}

.btn:hover:not(.btn-icon-only) {
  box-shadow: 0 3px 5px -1px rgb(53, 16, 32), 0 2px 3px -1px rgb(53, 16, 32) !important;
  transform: scale(1.02) !important;
  background-color: #b49b57 !important;
  color: rgb(53, 16, 32) !important;
}

.btn-info:hover {
  color: rgb(53, 16, 32) !important;
  background-color: white !important;
  border-color: rgb(53, 16, 32) !important;
}

.btn-info {
  border-color: #b49b57 !important;
}

.btn-info {
  --bs-btn-border-color: #b49b57 !important;
  --bs-btn-hover-border-color: #b49b57 !important;
  --bs-btn-active-border-color: #b49b57 !important;
  --bs-btn-disabled-border-color: #b49b57 !important;
}

.swal2-styled.swal2-confirm:focus {
  box-shadow: 0 0 0 3px #b49b57 !important;
}

.btn.focus,
.btn:focus {
  box-shadow: 0 0 0 0.2rem #b49b57 !important;
}

.page-item.active .page-link {
  background-color: rgb(53, 16, 32) !important;
  border-color: #b49b57 !important;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.btn-check:checked + .btn,
:not(.btn-check) + .btn:active,
.btn:first-child:active,
.btn.active,
.btn.show {
  background-color: #b49b57 !important;
  color: white !important;
}
.multiselect__option--highlight {
  background: #b49b57 !important;
  background-color: #b49b57 !important; /* Cambiar el color a vinotinto */
}

.multiselect__option--highlight:after {
  background: #b49b57 !important; /* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight {
  background: rgb(53, 16, 32) !important; /* Cambiar el color a vinotinto */
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: rgb(53, 16, 32) !important; /* Cambiar el color a vinotinto */
}

.rif-number {
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}

.rif-prefix {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.rif-number .form-control {
  border-top-right-radius: 30px !important;
  border-bottom-right-radius: 30px !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
  height: 40px !important;
  margin-top: 1px !important;
}

.rif-prefix .multiselect__tags {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.rif-prefix .multiselect__content-wrapper {
  border-top-left-radius: 30px !important;
  border-bottom-left-radius: 30px !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

.ticz-link {
  color: #a0a0a0;
  text-decoration: none;
  transition: color 0.3s ease-out;
}

.ticz-link:hover {
  background-image: linear-gradient(90deg, #b49b57, #f5e3a1);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: -100% 50%;
  animation: ticzHoverPaint 0.7s forwards;
}

@keyframes ticzHoverPaint {
  0% {
    background-position: -100% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>
